import { Option } from '../models/option.model';

export function isEmpty(value: any): boolean {
  return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
}

export function getEnumByValue<T>(enumType: T, value: string): T[keyof T] {
  const item = convertEnumToOptions(enumType).find(option => option.label === value);

  if (item) {
    return (enumType as any)[item.code];
  }

  throw new Error(`Value '${value}' not found in enum`);
}

export function convertEnumToOptions(enumType: any): Option[] {
  return Object.keys(enumType).map(key => ({ code: key, label: enumType[key] }));
}

export function isDate(date: Date | undefined): boolean {
  return date instanceof Date && !isNaN(date.getTime());
}

export function formatDateYYMMDD(date: Date | undefined) {
  const formattedDate: Date | undefined = date ? new Date(date) : undefined;
  const utcDate = formattedDate
    ? new Date(formattedDate.getUTCFullYear(), formattedDate.getUTCMonth(), formattedDate.getUTCDate())
    : undefined;

  return utcDate;
}

export function getLastFromArray<T>(array: T[]): T {
  return array[array.length - 1];
}

export function addClass(classes: string, newClass: string): string {
  return classes.includes(newClass) ? classes : classes.concat(newClass);
}

export function removeClass(classes: string, classToRemove: string): string {
  return classes.includes(classToRemove) ? classes.replace(classToRemove, '') : classes;
}

export function fixProductName(name: string = ''): string {
  return name?.replaceAll(',', ', ').replaceAll('  ', ' ');
}
